import { Badge, Divider, Dot, Flex, Skeleton, SkeletonBox, Text } from '@bitrise/bitkit';
import { DataTimeSeries } from '@trace/types';
import numbro from 'numbro';
import React, { FunctionComponent, Fragment } from 'react';
import getFormattedValue from '../../../utils/metric/getFormattedValue';
import { colorScale3, scaleZero } from '../../ViewVisualisations/colorScales';

interface Props {
  count: number;
  isFetching: boolean;
  versions: [string, DataTimeSeries][];
}

const placeholderSet: [string, DataTimeSeries][] = Array.from({ length: 3 }).map((_, i) => [
  `${i}`,
  [],
]);

const OverviewVersionMetrics: FunctionComponent<Props> = ({ count, isFetching, versions }) => {
  const metrics = isFetching ? placeholderSet : versions.slice(0, count);

  return (
    <Skeleton active={isFetching}>
      <Flex direction="horizontal" gap="x4" paddingVertical="x3">
        {metrics.map(([version, values], index, { length }) => (
          <Fragment key={version}>
            {isFetching ? (
              <Flex alignChildrenHorizontal="middle" direction="vertical" grow initial="none">
                <SkeletonBox height="1.5rem" margin="x1" width="5rem" />
                <SkeletonBox height="1.5rem" margin="x1" width="7rem" />
              </Flex>
            ) : (
              <Flex
                alignChildrenHorizontal="middle"
                direction="vertical"
                gap="x2"
                grow
                initial="none"
              >
                <Flex alignChildrenVertical="middle" direction="horizontal" gap="x3">
                  <Flex>
                    <Text config="5">{numbro(index + 1).format({ output: 'ordinal' })}</Text>
                  </Flex>

                  <Flex>
                    <Badge backgroundColor="gray-2" weight="bold">
                      {getFormattedValue('percent', values[values.length - 1])}
                    </Badge>
                  </Flex>
                </Flex>

                <Flex alignChildrenVertical="middle" direction="horizontal" gap="x1">
                  <Flex>
                    <Dot
                      size="12px"
                      style={{
                        backgroundColor: colorScale3(scaleZero(index, versions.length)),
                      }}
                    />
                  </Flex>

                  <Flex>
                    <Text config="7" weight="bold">
                      {version}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            )}

            {index < length - 1 && (
              <Flex>
                <Divider direction="vertical" width="1px" color="gray-3" />
              </Flex>
            )}
          </Fragment>
        ))}
      </Flex>
    </Skeleton>
  );
};

export default OverviewVersionMetrics;
